module.exports = __webpack_public_path__ + "img/cool.8e428e7d.svg";